import type { ClaimInitiativeAction } from "../types/actions";
import type { WarchestState } from "../types/game-state";
import {
  advanceActivePlayer,
  allHandsEmpty,
  moveCoin,
} from "../utils/zone-utils";

export function applyClaimInitiative(
  state: WarchestState,
  action: ClaimInitiativeAction,
): WarchestState {
  const zones = moveCoin(
    state.playerZones[action.player],
    action.coinType,
    "hand",
    "discardFaceUp",
  );
  const newPlayerZones = { ...state.playerZones, [action.player]: zones };
  const nextActive = advanceActivePlayer(action.player, newPlayerZones);
  const nextPhase = allHandsEmpty(newPlayerZones)
    ? ("DRAW_COINS" as const)
    : state.phase;
  return {
    ...state,
    playerZones: newPlayerZones,
    initiativeHolder: action.player,
    // The claim consumes the once-per-round lock, but if it also ended the
    // round (last coin played) the next round must start unlocked — mirror
    // every other round-ending applier (pass/control/...).
    initiativeTransferredThisRound: nextPhase !== "DRAW_COINS",
    activePlayer: nextActive,
    phase: nextPhase,
    turn: nextPhase === "DRAW_COINS" ? state.turn + 1 : state.turn,
  };
}
